import jQuery from "jquery";
const fromDate = document.getElementById("fromDate")?.value;
const toDate = document.getElementById("toDate")?.value;

let typeOfReport = "report";
let documentType = "pdf";

document.getElementById("format__pdf")?.addEventListener("click", () => {
  documentType = "pdf";
});

document.getElementById("format__excel")?.addEventListener("click", () => {
  documentType = "csv";
});

document.getElementById("reportType")?.addEventListener("change", (e) => {
  typeOfReport = e.target.value;
});

document.getElementById("generatesummary")?.addEventListener("click", () => {
  window.open(
    `/courses/completed${typeOfReport}as${documentType}/?fromDate=${fromDate}&toDate=${toDate}`,
    "_blank"
  ) ||
    window.location.replace(
      `/courses/completed${typeOfReport}as${documentType}/?fromDate=${fromDate}&toDate=${toDate}`
    );
});

// Get the root element
var r = document.querySelector(":root");

// Create a function for setting a variable value
function myFunction_set() {
  let box = document.querySelector(".course__documents-wrapper");
  let height = box.clientHeight;

  // Set the value of variable --blue to another value (in this case "lightblue")
  r.style.setProperty("--courses-docs-height", height + "px");
}

var elements = document.getElementsByClassName("course__documents-btn");

var expandCoursesDocuments = function () {
  let expanded = this.getAttribute("aria-pressed") === "true" || false;
  this.setAttribute("aria-pressed", !expanded);
  if (!expanded) {
    var closestCourse = this.closest(".course");
    closestCourse.classList.add("course--expanded");
    let courseWrapper = this.nextElementSibling;
    let height = courseWrapper.clientHeight;
    closestCourse.style.paddingBottom = height + 24 + "px";
  } else {
    var closestCourse = this.closest(".course");
    closestCourse.classList.remove("course--expanded");
    closestCourse.style.paddingBottom = "";
  }
};

Array.from(elements).forEach(function (element) {
  console.log("Test test");
  element.addEventListener("click", expandCoursesDocuments);
});
